var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-filter-pop-up"},[_vm._m(0),_c('div',{staticClass:"widget-filter-pop-up-body"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-filter-pop-up-header"},[_c('h3',[_vm._v("Filter")])])
}]

export { render, staticRenderFns }